import { htmlToText } from "html-to-text";

export function htmlToCaption(html) {
    return htmlToText(html, {
        wordwrap: false,
        selectors: [
            {
                selector: "a",
                options: {
                    hideLinkHrefIfSameAsText: true,
                    ignoreHref: true,
                },
            },
            {
                selector: "li",
                format: "inline",
                options: { bullet: "• " },
            },
            {
                selector: "p",
                options: { leadingLineBreaks: 1, trailingLineBreaks: 1 },
            },
        ],
    });
}

export function captionToHtml(caption) {
    return "<p>" +
        caption.replace(/\n+/g, "</p><p>") +
        "</p>";
}

export function captionToHtmlIfNeeded(caption) {
    return caption.includes("<p>") ?
        caption :
        captionToHtml(caption);
}
